module.exports = __webpack_public_path__ + "static/img/2.0ea7f78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/1/2.png
// module id = tXJN
// module chunks = 0